define('models/StoreAvisVerifieModel',['underscore', 'ObjectModel', 'LocalStorage', 'moment'], function (
    _,
    ObjectModel,
    LocalStorage,
    moment
) {
    var StoreAvisVerifieModelPrototype = {
        name: 'StoreAvisVerifieModel',
        idAttribute: 'id_store',
        route: 'apiStoreAvisVerifie',
        remoteCache: 'no-cache',

        defaults: {
            id_store: '',
            avg_avis: '0',
            count_avis: 0,
            avis: [],
            avis_certificate_url: '',
            states: {
                1: '0',
                2: '0',
                3: '0',
                4: '0',
                5: '0',
            },
            starFilter: '',
        },
        initialize: function () {
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this, arguments);

            //
            if (!this.get(this.idAttribute)) {
                this.attributes[this.idAttribute] = this.get('id');
            }
        },
        url: function () {
            var model = this;
            return ObjectModel.prototype.url.apply(model, [
                {
                    id_store: model.get('id_store'),
                    stars: model.get('starFilter') || 0,
                },
            ]);
        },
        getComments: function () {
            return this.attributes['avis']
                ? this.attributes['avis'].map(function (c) {
                    c.order_date = moment(c.order_date).format('DD/MM/YYYY')
                      return c;
                  })
                : [];
        },
        getStates: function () {
            const states = this.attributes['states'];
            return states;
        },
        getCertificateUrl: function () {
            return this.attributes['avis_certificate_url'];
        },
    };

    var StoreAvisVerifie = ObjectModel.extend(LocalStorage).extend(
        StoreAvisVerifieModelPrototype
    );

    return StoreAvisVerifie;
});

